export abstract class AuthStoreStrategy {
  abstract userSub(): string;
}
